import { Box, Flex, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

interface WizardStepIndicatorProps {
  stepCount: number;
  currentStep: number;
}

export function WizardStepIndicator({
  stepCount,
  currentStep,
}: WizardStepIndicatorProps) {
  const [t] = useTranslation();
  return (
    <Flex align="center" gap="8px">
      {Array.from({ length: stepCount }).map((_, i) => {
        const stepNum = i + 1;
        const isActive = stepNum === currentStep;
        const isDone = stepNum < currentStep;
        return (
          <Box
            key={i}
            flex="1"
            h="3px"
            borderRadius="2px"
            bg={
              isActive
                ? "blaze.blaze"
                : isDone
                  ? "blaze.blaze_40"
                  : "transparent.white.10"
            }
            transition="background 0.25s ease"
          />
        );
      })}
      <Text
        fontSize="10px"
        letterSpacing="0.7px"
        textTransform="uppercase"
        fontWeight={500}
        color="dune.700"
        whiteSpace="nowrap"
      >
        {t("screens.shelf.readingLists.wizard.progress", {
          current: currentStep,
          total: stepCount,
        })}
      </Text>
    </Flex>
  );
}
